var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.4509 8.27705L11.8675 4.31912C11.4663 3.97263 10.834 4.25391 10.834 4.79214V6.87685C6.65094 6.92474 3.33398 7.76309 3.33398 11.7273C3.33398 13.3273 4.36474 14.9124 5.50412 15.7412C5.85966 15.9998 6.36638 15.6752 6.23529 15.256C5.05445 11.4796 6.79537 10.477 10.834 10.419V12.7084C10.834 13.2475 11.4668 13.5275 11.8675 13.1814L16.4509 9.22309C16.7392 8.97408 16.7396 8.5264 16.4509 8.27705Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0a52fee333e9c32b5c3bbe3d02d7b988.svg";
export { ForwardRef as ReactComponent };